import _iteratorsCore from "../internals/iterators-core";
import _objectCreate from "../internals/object-create";
import _createPropertyDescriptor from "../internals/create-property-descriptor";
import _setToStringTag from "../internals/set-to-string-tag";
import _iterators from "../internals/iterators";
var exports = {};
var IteratorPrototype = _iteratorsCore.IteratorPrototype;
var create = _objectCreate;
var createPropertyDescriptor = _createPropertyDescriptor;
var setToStringTag = _setToStringTag;
var Iterators = _iterators;
var returnThis = function () {
  return this;
};
exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + " Iterator";
  IteratorConstructor.prototype = create(IteratorPrototype, {
    next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next)
  });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};
export default exports;